module.exports = __webpack_public_path__ + "static/media/menuCalendar.bac2205b.svg";